/* ============================================================
 * EcoSmiles · GTM ecommerce hooks
 * Captura add_to_cart, view_cart, remove_from_cart de forma universal
 * sin importar de donde se dispare (PDP, quick-add, cart drawer, etc.)
 *
 * Inyectado por Claude el 2026-06-02
 * ============================================================ */
(function() {
  if (window.__gtmEcommerceHooksLoaded) return;
  window.__gtmEcommerceHooksLoaded = true;
  window.dataLayer = window.dataLayer || [];

  function getCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MXN';
  }

  function buildItem(item) {
    var priceCents = item.final_price || item.price || 0;
    return {
      item_id: item.sku || String(item.product_id || item.id),
      item_name: item.product_title || item.title || '',
      item_brand: 'EcoSmiles',
      item_category: item.product_type || '',
      item_variant: item.variant_title || '',
      price: priceCents / 100,
      quantity: item.quantity || 1
    };
  }

  function totalCents(items) {
    return items.reduce(function(s, i) { return s + ((i.final_price || i.price || 0) * (i.quantity || 1)); }, 0);
  }

  function pushCartEvent(event, items) {
    var gtmItems = items.map(buildItem);
    var value = totalCents(items) / 100;
    window.dataLayer.push({
      event: event,
      ecommerce: { currency: getCurrency(), value: value, items: gtmItems }
    });
  }

  // 1) Hook fetch para detectar /cart/add.js
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function(input, init) {
      return origFetch.apply(this, arguments).then(function(response) {
        try {
          var u = (typeof input === 'string') ? input : ((input && input.url) || '');
          if (u.indexOf('/cart/add') !== -1 && response.ok) {
            response.clone().json().then(function(data) {
              var items = data.items || (data.id ? [data] : []);
              if (items.length) pushCartEvent('add_to_cart', items);
            }).catch(function(){});
          } else if (u.indexOf('/cart/change') !== -1 && response.ok) {
            // remove or update — capturamos si cantidad va a 0
            response.clone().json().then(function(data) {
              if (data && data.items) {
                window.dataLayer.push({
                  event: 'cart_update',
                  ecommerce: { currency: getCurrency(), value: (data.total_price || 0) / 100,
                                items: data.items.map(buildItem) }
                });
              }
            }).catch(function(){});
          }
        } catch(e) { console.warn('GTM ecommerce hook:', e); }
        return response;
      });
    };
  }

  // 2) Hook XHR (algunos themes viejos no usan fetch)
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function() {
    var xhr = this;
    var origReady = xhr.onreadystatechange;
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 200 && xhr._url && xhr._url.indexOf('/cart/add') !== -1) {
        try {
          var data = JSON.parse(xhr.responseText);
          var items = data.items || (data.id ? [data] : []);
          if (items.length) pushCartEvent('add_to_cart', items);
        } catch(e) {}
      }
      if (origReady) origReady.apply(this, arguments);
    };
    return origSend.apply(this, arguments);
  };

  // 3) view_cart cuando se visita /cart o se abre cart drawer
  if (window.location.pathname === '/cart' || window.location.pathname.match(/^\/cart\/?$/)) {
    // Fetch cart actual y dispatch
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
      if (cart.items && cart.items.length) {
        window.dataLayer.push({
          event: 'view_cart',
          ecommerce: { currency: getCurrency(), value: (cart.total_price || 0) / 100,
                       items: cart.items.map(buildItem) }
        });
      }
    }).catch(function(){});
  }
})();
